import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import "./index.css";
import "./components/Common_Component/Common_Css/Common_Css.css";
import "./components/Common_Component/Common_Css/Form_Css.css";
import ChatBot from 'react-chatbotify'
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import AppContext from "./utils/context";
import You_Are_Almost_There_Modal from "./components/Common_Component/Common_Modal/You_Are_Almost_There_Modal/You_Are_Almost_There_Modal";

import Thank_you from "./components/Thank-you/Thank_you";
import Terms_Conditions from "./components/Terms_Conditions/Terms_Conditions";
import Privacy_Policy from "./components/Privacy_Policy/Privacy_Policy";


import { Button } from "react-bootstrap";
import Eligibility_criteria_details from "./components/eligibility_criteria_details/Eligibility_criteria_details";
import See_Your_EMI from "./components/sitelinks/See_Your_EMI/See_Your_EMI";
import FAQ from "./components/sitelinks/FAQ/FAQ";
import Apply_Now from "./components/sitelinks/Apply_Now/Apply_Now";
import Why_Profcyma from "./components/sitelinks/Why_Profcyma/Why_Profcyma";
import Contact_support from "./components/sitelinks/Contact_support/Contact_support";

function App() {
  const [modalShow, setModalShow] = useState(false);
  const [modalShownOnce, setModalShownOnce] = useState(false);
  const location = useLocation();




  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const pageHeight = document.body.scrollHeight - window.innerHeight;

      if (
        location.pathname === "/" &&
        scrollY > pageHeight / 2 &&
        !modalShownOnce
      ) {
        setModalShow(true);
        setModalShownOnce(true); // Show only once
      }
    };

    if (location.pathname === "/") {
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname, modalShownOnce]);

  const scrollToSection = (id, offset = 100) => {
    const section = document.getElementById(id);
    if (section) {
      const top = section.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <>
      <AppContext>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thank-you" element={<Thank_you />} />
          <Route path="/terms-conditions" element={<Terms_Conditions />} />
          <Route path="/privacy-policy" element={<Privacy_Policy />} />
          <Route path="/check-eligibility-criteria" element={<Eligibility_criteria_details />} />
          <Route path="/see-your-emi" element={<See_Your_EMI />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/apply-now" element={<Apply_Now />} />
          <Route path="/why-profcyma" element={<Why_Profcyma />} />
          <Route path="/contact-support" element={<Contact_support />} />


        </Routes>
        <Footer />
      </AppContext>

      <div className="inquirybtndiv">
        <Button className="inquirybtn" onClick={() => setModalShow(true)}>
          Inquiry
        </Button>

        <Button className="inquirybtn watsappbtn" onClick={() => window.open('https://wa.me/+918956368061', '_blank')}>
          WhatsApp
        </Button>

        <Button className="inquirybtn Phonebtn" onClick={() => window.open('tel:8956368061', '_blank')}>
          Call Us
        </Button>


      </div>

      {/* {location.pathname === "/"  &&  ( */}
      <You_Are_Almost_There_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}

      />
      {/* <ChatBot /> */}
      {/* )} */}
    </>
  );
}

export default App;
